import { Navigate } from 'react-router-dom'
import { useUser } from '../context/CurrentUserContext'
import ErrorPage from './ErrorPage'

const ProtectedRoute = ({ element: Component, allowedRoles }) => {
  const { user, loading } = useUser()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && !allowedRoles.some((role) => user.role === role)) {
    return (
      <ErrorPage
        status={403}
        title="Access restricted"
        message="You do not have access to this resource"
      />
    )
  }

  return Component
}

export default ProtectedRoute
